import { SearchCsUsers } from "../../../../Utils/AllPagesQuriesAndMutations";

const UserPaymentTermsManagementFields = [
  {
    id: Math.random() * 10,
    name: "User_payment_terms",
    fields: [
      {
        id: Math.random() * 10,
        name: "UserId",
        label: "User ID",
        dropdowndata: SearchCsUsers,
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Note",
        label: "Note",
        type: "textarea",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

export { UserPaymentTermsManagementFields };
